
export default (t) => t;


// WEBPACK FOOTER //
// ./src/locale.js